import React, { useEffect, useState } from "react";
import Amplify, { Auth } from "aws-amplify";
import { useAuth } from "../../hooks/useAuth";

import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import { get } from "../../api";
import awsConfig from "../../aws-exports";
import { getAllUrlParams } from "../../utils";
import { Alert, Backdrop, CircularProgress } from "@mui/material";

const LoginWithAccess = () => {
    const { loginWithToken } = useAuth();
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const query = getAllUrlParams(window.location.search);
    const token = query?.token;

    useEffect(() => {
        const loginWithRefreshToken = async () => {
            try {
                if (token) {
                    let data = {
                        UserPoolId: awsConfig.aws_user_pools_id,
                        ClientId: awsConfig.aws_user_pools_web_client_id,
                        Token: token,
                    };
                    get("auth/loginWithToken", {
                        token: token,
                        clientId: data.ClientId,
                    }).then((result) => {
                        if (result.isSuccess) {
                            console.log(result);
                            let accessData = result.data;
                            if (accessData) {
                                accessData.userPoolId = data.UserPoolId;
                                accessData.clientId = data.ClientId;
                                loginWithToken(result.data);
                            }
                        } else {
                            setErrorMessage(result.errorMessage);
                            setLoading(false);
                        }
                    });
                }
            } catch (error) {
                console.error("Login error:", error);
            }
        };

        loginWithRefreshToken();
    }, []);

    const handleClose = () => {
        setLoading(false);
    };

    return (
        <div>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleClose}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default LoginWithAccess;
